import { combineReducers } from 'redux';
import { authReducer, userSessionReducer, updatingUserReducer, updatingUserHistoryRecordReducer } from './authReducer.js';
import { listPostedSchedulesReducer, postedSchedulesReducer,postedSchedulesJSONReducer , listPreviousPostingsReducer, resourceCollectionInformationReducer,
createPostedScheduleReducer, postedScheduleParametersReducer } from './postedScheduleReducer.js';
import { resourceReducer, selectedResourceReducer, selectedDayTypeResourceReducer, resourcePersonnelDataReducer, resourceContactInfoReducer } from './resourceReducer.js';
import {
  listResourceCollectionReducer, liveSchedulesReducer, editModeReducer,
  liveScheduleOptimisticReRenderReducer, liveScheduleOptimisticScheduleReducer,
  liveScheduleParametersReducer
} from './liveScheduleReducer.js';
import { listMyQuickSchedulesReducer, updateMyQuickSchedulesArrayReducer } from './myQuickScheduleReducer.js';
import { detailedSchedulesReducer, detailedScheduleParametersReducer } from './detailedScheduleReducer.js';
import { selectedResourceCollectionReducer } from './selectedResourceCollectionReducer.js';
import {
  dayTypeCalendarReducer, dayTypeSecurityReducer, resourceDayTypeReducer,
  dayTypeRequestsByYearReducer, dayTypesAllReducer, dayTypeRequestByIdReducer, dayTypeReducer,
  dayTypesByDayRuleReducer, dayTypesAllowingTourSchedulingReducer, dayTypeCalendarScheduleParametersReducer,
  dayTypesAllWithoutForceTourReducer, ifHasHolidayScheduleReducer
} from './dayTypeReducer.js';
import { createTourPreReqReducer, tourReducer, activeToursReducer, defaultTourLengthReducer,
  tourActivityFlagReducer, tourPayTransactionReducer, tourPayTransactionsReducer, tourIndicatorsReducer, activityFlagByTourReducer,
  tourActivityFlagsReducer, codesByIndicatorReducer, indicatorsByIdReducer, indicatorsByTourReducer,
  jobElementsByTourReducer, tourMealsReducer, payTransactionsByTourReducer, tourIndicatorReducer, ifToursAreInDateRangeReducer
} from './tourReducer.js';
import { mealReducer } from './mealReducer.js';
import { navigationReducer } from './navigationReducer.js';
import {
  costObjectsReducer, relevantJobsReducer, relevantJobsForCostObjectReducer,
  relatedBranchesReducer, groupsByBranchAndResourceReducer, servicesByDateReducer,
  activityTypesReducer, logJobStartRecordReducer, jobReducer, jobElementReducer,
  logJobFinishRecordReducer, serviceSalaryLevelReducer, servicePrimaryRateReducer,
  serviceJobSalariesReducer, validateEmptyJobReducer, costObjectReducer,
  jobElementsWithDetailsReducer, serviceReducer, groupsByBranchInCompanyReducer,
  assignmentServicesByGroupReducer, servicesByGroupReducer, approvedJobElementsReducer,
  jobElementsReducer
} from './assignmentReducer.js';
import {
  approvalReducer, approvalParametersReducer, timeKeeperCheckForTourReducer,
  tourIsDirectBillingReducer, contactInfoForAssignmentReducer, tourReversalReducer,
  branchesByCompanyIdReducer, divisionsByBranchIdReducer, departmentsByCompanyIdBranchIdDivisionIdReducer
 } from './approvalReducer.js';
import { branchReducer } from './userReducer.js';



const rootReducer = combineReducers({
  auth: authReducer,
  user: userSessionReducer,
  listPostedSchedules: listPostedSchedulesReducer,
  resources: resourceReducer,
  postedSchedules: postedSchedulesReducer,
  postedSchedulesJSON: postedSchedulesJSONReducer,
  selectedResource: selectedResourceReducer,
  selectedDayTypeResource: selectedDayTypeResourceReducer,
  selectedResourceCollection: selectedResourceCollectionReducer,
  listResourceCollections: listResourceCollectionReducer,
  liveSchedules: liveSchedulesReducer,
  listPreviousPostings: listPreviousPostingsReducer,
  listMyQuickSchedules: listMyQuickSchedulesReducer,
  myQuickSchedulesArray: updateMyQuickSchedulesArrayReducer,
  detailedSchedules: detailedSchedulesReducer,
  dayTypeCalendar: dayTypeCalendarReducer,
  dayTypeSecurity: dayTypeSecurityReducer,
  editMode: editModeReducer,
  createTourPreReq: createTourPreReqReducer,
  resourceDayType: resourceDayTypeReducer,
  tour: tourReducer,
  meal: mealReducer,
  dayTypesAll: dayTypesAllReducer,
  dayTypesAllWithoutForceTour:dayTypesAllWithoutForceTourReducer,
  liveScheduleOptimisticReRender: liveScheduleOptimisticReRenderReducer,
  liveScheduleOptimisticSchedule: liveScheduleOptimisticScheduleReducer,
  resourcePersonnelData: resourcePersonnelDataReducer,
  dayType: dayTypeReducer,
  dayTypeRequestsByYear: dayTypeRequestsByYearReducer,
  dayTypeRequestInfo: dayTypeRequestByIdReducer,
  navigation: navigationReducer,
  createPostedSchedule: createPostedScheduleReducer,
  relevantJobs: relevantJobsReducer,
  costObjects: costObjectsReducer,
  relevantJobsForCostObject: relevantJobsForCostObjectReducer,
  relatedBranches: relatedBranchesReducer,
  groupsByBranchAndResource: groupsByBranchAndResourceReducer,
  servicesByDate: servicesByDateReducer,
  activityTypes: activityTypesReducer,
  serviceSalaryLevel: serviceSalaryLevelReducer,
  servicePrimaryRate: servicePrimaryRateReducer,
  serviceJobSalaries: serviceJobSalariesReducer,
  logJobStartRecord: logJobStartRecordReducer,
  logJobFinishRecord: logJobFinishRecordReducer,
  job: jobReducer,
  jobElement: jobElementReducer,
  activeTours: activeToursReducer,
  defaultTourLength: defaultTourLengthReducer,
  validateEmptyJob: validateEmptyJobReducer,
  resourceCollectionInformation: resourceCollectionInformationReducer,
  costObject: costObjectReducer,
  jobElementsWithDetails: jobElementsWithDetailsReducer,
  service: serviceReducer,
  groupsByBranchInCompany: groupsByBranchInCompanyReducer,
  assignmentServicesByGroup: assignmentServicesByGroupReducer,
  servicesByGroup: servicesByGroupReducer,
  updatingUser: updatingUserReducer,
  updatingUserHistoryRecord: updatingUserHistoryRecordReducer,
  approvals: approvalReducer,
  approvalParameters: approvalParametersReducer,
  timeKeeperCheckForTour: timeKeeperCheckForTourReducer,
  tourIsDirectBilling: tourIsDirectBillingReducer,
  contactInfoForAssignment: contactInfoForAssignmentReducer,
  tourReversal: tourReversalReducer,
  approvedJobElements: approvedJobElementsReducer,
  jobElements: jobElementsReducer,
  tourActivityFlag: tourActivityFlagReducer,
  tourIndicators: tourIndicatorsReducer,
  tourPayTransaction: tourPayTransactionReducer,
  tourPayTransactions: tourPayTransactionsReducer,
  activityFlagByTour: activityFlagByTourReducer,
  tourActivityFlags: tourActivityFlagsReducer,
  codesByIndicator: codesByIndicatorReducer,
  indicatorsById: indicatorsByIdReducer,
  indicatorsByTour: indicatorsByTourReducer,
  jobElementsByTour: jobElementsByTourReducer,
  tourMeals: tourMealsReducer,
  payTransactionsByTour: payTransactionsByTourReducer,
  tourIndicator: tourIndicatorReducer,
  branchesByCompanyId: branchesByCompanyIdReducer,
  divisionsByBranchId: divisionsByBranchIdReducer,
  departmentsByCompanyIdBranchIdDivisionId: departmentsByCompanyIdBranchIdDivisionIdReducer,
  resourceContactInfo: resourceContactInfoReducer,
  dayTypesByDayRule: dayTypesByDayRuleReducer,
  dayTypesAllowingTourScheduling: dayTypesAllowingTourSchedulingReducer,
  branch: branchReducer,
  ifToursAreInDateRange: ifToursAreInDateRangeReducer,
  postedScheduleParameters: postedScheduleParametersReducer,
  detailedScheduleParameters: detailedScheduleParametersReducer,
  dayTypeCalendarScheduleParameters: dayTypeCalendarScheduleParametersReducer,
  liveScheduleParameters: liveScheduleParametersReducer,
  ifHasHolidaySchedule: ifHasHolidayScheduleReducer
});

export default rootReducer;
